export default (items, size) => {
    var output = []

    for (var i = 0; i < items.length; i += size) {
        output[output.length] = items.slice(i, i + size)
    }
    return output;
}